import * as React from 'react';

import { cn } from '@/lib/utils';

const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea
    className={cn(
      'flex min-h-[80px] w-full border-2 border-[#1a1a1a] bg-[#fefcf6] px-3 py-2 text-base placeholder:text-[#8a7e6b] focus-visible:outline-none focus-visible:border-[#d62828] focus-visible:shadow-[3px_3px_0px_#d62828] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
      className
    )}
    ref={ref}
    {...props}
  />
));
Textarea.displayName = 'Textarea';

export { Textarea };
